import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "box-row items-center" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "box-row items-center tw-ml-4" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = {
  key: 0,
  class: "tw-pl-4 tw-text-[11px] text-negative q-field--error tw-font-medium tw-pt-2"
}

import { computed, ref, watch } from "vue"
 
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ProductTypeSelect',
  props: {
    modelValue: {
      type: Number,
      default: null,
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'update:modelValue'
  ],
  setup(__props, { expose: __expose, emit: __emit }) {

  const props = __props

  const value = computed<number | null>({
    get() {
      return props.modelValue
    },
    set(value: number | null) {
      emit('update:modelValue', value)
    }
  })

  const emit = __emit

  watch(() => value.value, () => {
    valid.value = validate();
  })

  const validated = ref(false);
  const valid = ref(false)
  function validate(){
    if(!props.required) return true;

    validated.value = true;
    valid.value = value.value !== null;
    return valid.value;
  }
  __expose({ validate })

return (_ctx: any,_cache: any) => {
  const _component_q_radio = _resolveComponent("q-radio")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_q_radio, {
            modelValue: value.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
            val: 1,
            size: "sm",
            dense: ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", {
          class: "tw-pl-2 content cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (value.value = 1))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["tw-text-sm", validated.value && !valid.value ? 'text-negative q-field--error' : 'tw-text-slate-600'])
          }, "PCP", 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_q_radio, {
            modelValue: value.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((value).value = $event)),
            val: 0,
            size: "sm",
            dense: ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", {
          class: "tw-pl-2 content cursor-pointer",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (value.value = 0))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["tw-text-sm", validated.value && !valid.value ? 'text-negative q-field--error' : 'tw-text-slate-600'])
          }, "HP", 2)
        ])
      ])
    ]),
    (__props.required && validated.value && !valid.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Please select a product type "))
      : _createCommentVNode("", true)
  ], 64))
}
}

})